export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';

export const setSelectedCategory = (id) => ({
  type: SET_SELECTED_CATEGORY,
  payload: {
    id,
  },
});
